import React from "react";
import { PlusCircle } from "react-bootstrap-icons";
import HotSheetPriority from "./HotSheetPriority";

function Priorities({ priorities, onAdd, onUpdate, onDelete }) {
  return (
    <div className="container mt-3">
      <div className="row mb-2">
        <div className="col">
          <label className="fs-5 fw-bold">Priorities</label>
          <span className="ms-3" role="button" onClick={onAdd}>
            <PlusCircle size={24} />
          </span>
        </div>
      </div>
      {priorities.map((p) => (
        <HotSheetPriority
          key={p.no}
          priority={p}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

export default Priorities;
